module.exports = __webpack_public_path__ + "static/media/eu_flagge.c2fda179.png";